export default __webpack_public_path__ + "static/media/sarto.c61e02f9.png";